
export const messages = {
    ENRICHMENT_CONTACTREVEAL_SUCCESS: 'Contact revealed successfully!',
    ENRICHMENT_CONTACTREVEAL_FAILED: 'No profiles were found matching your criteria',
    ENRICHMENT_CONTACTREVEAL_CONTACT_MISSING: 'No contacts were found for this profile',
}
export const infoMessages = {
    LOADING_DATA: 'Loading data, please wait...',
    SAVING_DATA: 'Saving data, please wait...',
    DELETING_DATA: 'Deleting data, please wait...',
    UPDATING_DATA: 'Updating data, please wait...',
    SIGNINGUP: 'Signing up, please wait...',
    REVEALING_CONTACT: 'Revealing contact information, please wait...'
}
export const validationMessages = {
    EMPTY_FIELD: 'This field is required',
    VALID_URL: 'Please enter a valid URL',
    VALID_EMAIL: 'Please enter a valid email',
    VALID_PHONE: 'Please enter a valid phone number',
    VALID_NAME: 'Please enter a valid name',
    VALID_COMPANY: 'Please enter a valid company name',
    VALID_DOMAIN: 'Please enter a valid domain',
    VALID_ADDRESS: 'Please enter a valid address',
    VALID_CITY: 'Please enter a valid city',
    VALID_STATE: 'Please enter a valid state',
    URL_ALREADY_EXISTS: 'This URL already added',
    URL_TOO_LONG: 'URL is too long'
   
}
export const errorMessages = {
    FAILED_REMOVE_URL: 'Failed to remove URL',
    SOMETHING_WENT_WRONG: 'Something went wrong, please try again later',
    INVALID_CREDENTIALS: 'Invalid credentials, please try again',
    USER_NOT_FOUND: 'User not found',
    EMAIL_ALREADY_EXISTS: 'Email already exists',
    PASSWORD_TOO_WEAK: 'Password is too weak',
    ACCOUNT_LOCKED: 'Account is locked, please contact support',
    INVALID_TOKEN: 'Invalid token, please try again',
    TOKEN_EXPIRED: 'Token has expired, please request a new one',
    UNAUTHORIZED_ACCESS: 'Unauthorized access, please login again',
    FAILED_SIGNUP: 'Failed to sign up, please try again',
    FORBIDDEN_ACCESS: 'Forbidden access, you do not have permission to access this resource',
    ENRICHMENT_CONTACTREVEAL_CONTACT_MISSING: 'No contacts were found for this profile',
    ENRICHMENT_CONTACTREVEAL_FAILED: 'No profiles were found matching your criteria',
}
export const successMessages = {
    URL_REMOVED_SUCCESS: 'URL removed successfully',
    ADD_SUCCESS: 'Added successfully',
    UPDATE_SUCCESS: 'Updated successfully',
    DELETE_SUCCESS: 'Deleted successfully',
    LOGIN_SUCCESS: 'Logged in successfully',
    LOGOUT_SUCCESS: 'Logged out successfully',
    SIGNUP_SUCCESS: 'Signed up successfully',
    PASSWORD_RESET_SUCCESS: 'Password reset successfully',
    PASSWORD_CHANGE_SUCCESS: 'Password changed successfully',
    URL_ADDED_SUCCESS: 'URL added successfully',
    ENRICHMENT_CONTACTREVEAL_SUCCESS: 'Contact revealed successfully!',
}
export const emptyMessages = {
    websiteTraffic: 'No website traffic',
    conversions: 'No conversions',
    socialIntent: 'No Mentions Found',
    keywords: 'No keywords added',
    found: 'No results found',
    matchingResult: 'No matching results were found',
    integrations: 'No integrations available'
}